export default __webpack_public_path__ + "static/media/play.146ebd55.svg";